import { TextField } from '@shared/design-system/ui'
import { useAdminUserSearch } from '../api/admin.api'
import { AdminUserResolutionHint } from './AdminUserResolutionHint'
import type { useResolvedAdminUser } from './useResolvedAdminUser'
import {
  userSearchWrap,
  userSuggestionButton,
  userSuggestionMeta,
  userSuggestions,
} from './admin.css'

type AdminUserSearchFieldProps = {
  label?: string
  value: string
  onChange: (value: string) => void
  state: ReturnType<typeof useResolvedAdminUser>
  placeholder?: string
}

export function AdminUserSearchField({
  label = 'Usuário',
  value,
  onChange,
  state,
  placeholder = 'e-mail do usuário',
}: AdminUserSearchFieldProps) {
  const search = useAdminUserSearch(value)
  const suggestions = search.data?.items ?? []
  const showSuggestions = value.trim().length >= 2 && !state.resolvedUser && !state.isUserIdQuery

  return (
    <div className={userSearchWrap}>
      <TextField
        label={label}
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
        placeholder={placeholder}
        belowSlot={<AdminUserResolutionHint state={state} />}
      />
      {showSuggestions ? (
        <div className={userSuggestions}>
          {search.isLoading ? <span className={userSuggestionMeta}>Buscando...</span> : null}
          {!search.isLoading && suggestions.length === 0 ? (
            <span className={userSuggestionMeta}>Nenhum usuário encontrado.</span>
          ) : null}
          {suggestions.map((user) => (
            <button
              type="button"
              className={userSuggestionButton}
              key={user.id}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => {
                onChange(user.email)
              }}
            >
              <span>{user.email}</span>
              {user.name ? <span className={userSuggestionMeta}>{user.name}</span> : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  )
}
